import type { ICreateArticleProductionSiteAllocation } from "@/data/commands/catalog/CreateArticleCmd";
import type { IArticleProductionSiteAllocation } from "@/data/model/Article";

import { i18n } from "@/portal/Trans";
import { ArticleProductionSiteAllocatorRow } from "@/portal/elements/ArticleProductionSiteAllocatorRow";

export class ArticleProductionSiteAllocator {
    private $element: JQuery;
    private $container: JQuery;

    private allocations: Array<ArticleProductionSiteAllocatorRow> = [];

    constructor() {
        this.$element = $('<div class="article-production-site-allocator mb-4"/>');
        const row = $('<div class="row mb-2"></div>').appendTo(this.$element);
        $(
            '<label class="col-xl-3"></label><div class="col-xl-3 pull-right col-form-label"><h3 class="kt-section__title kt-section__title-sm mb-2">' +
                i18n("general.entities.productionSites") +
                '</h3><span class="form-text text-muted mb-2">' +
                i18n("elements.productionSiteAllocator.subtitle") +
                "</span></div>"
        ).appendTo(row);
        const addBtn = $(
            '<div class="col-xl-3 pull-right mb-4"><button type="button" class="btn pull-right btn-success"><i class="la la-plus"></i> ' +
                i18n("general.entities.productionSite") +
                "</button></div>"
        )
            .appendTo(row)
            .find("> .btn");
        addBtn.click((e) => {
            e.preventDefault();

            if (this.allocations.length === 0) {
                this.$container.empty();
            }

            this.renderRow();
        });

        this.$container = $('<div class="allocations-container"/>').appendTo(this.$element);
        $("<hr>").appendTo(this.$element);
    }

    public setValue(productionSiteAllocations: Array<IArticleProductionSiteAllocation>) {
        this.$container.empty();
        this.allocations = new Array<ArticleProductionSiteAllocatorRow>();

        if (productionSiteAllocations.length === 0) {
            this.renderEmptySection();
        } else {
            for (const allocation of productionSiteAllocations) {
                this.renderRow(allocation);
            }
        }
    }

    public getValues(): Array<ICreateArticleProductionSiteAllocation> {
        const result = new Array<ICreateArticleProductionSiteAllocation>();
        for (const allocationRow of this.allocations) {
            result.push(allocationRow.getValues());
        }
        return result;
    }

    /// Returns true if all rows are valid, otherwise returns false
    public validateRows(): boolean  {
        let areRowsValid = true;
        for (const allocationRow of this.allocations) {
            
            if (!allocationRow.validateRow()) {
                areRowsValid = false;
            }
        }
        
        return areRowsValid;
    }

    private renderRow(allocation?: IArticleProductionSiteAllocation) {
        const row = new ArticleProductionSiteAllocatorRow(this.$container, () => {
            const index = this.allocations.indexOf(row);
            if (index > -1) {
                this.allocations.splice(index, 1);
            }

            if (this.allocations.length === 0) {
                this.renderEmptySection();
            }
        });
        if (allocation != null) {
            row.setValue(allocation);
        }
        this.allocations.push(row);
    }

    private renderEmptySection() {
        $(
            '<div class="nodata" style="padding: 10px 0; color: #7f849a; text-align: center;">' +
                i18n("elements.productionSiteAllocator.noProductionSites") +
                "</div>"
        ).appendTo(this.$container);
    }

    public replaceWith($element: JQuery): ArticleProductionSiteAllocator {
        $element.replaceWith(this.$element);

        return this;
    }
}
